import { useState } from "react";
import { Box } from "@chakra-ui/react";
import TableFuelEmployees from "./tableFuelEmployees";
import TableFuelRequests from "./tableFuelRequests";
import TableFuelHistory from "./tableFuelHistory";

// Xăng xe: NV nhận xăng xe phải chấm ra mới đủ công, không nhận thì không cần chấm ra

export default function FuelAllowance() {
  const [tab, setTab] = useState(0);

  const props = { tab, setTab };
  const content = [
    <TableFuelEmployees {...props} />,
    <TableFuelRequests {...props} />,
    <TableFuelHistory {...props} />,
  ][tab];

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      {content}
    </Box>
  );
}
